import TrackingService from '../services/TrackingService';
import router from '@/router';

const getDefaultState = () => ({
  trackings: [],
  tracking: {
    country: '',
    region: '',
    district: '',
    village: '',
    address: '',
    lat: null,
    lng: null,
  },
});

const trackings = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    trackings(state, val) {
      state.trackings = val;
    },
    country(state, val) {
      state.tracking.country = val;
    },
    region(state, val) {
      state.tracking.region = val;
    },
    district(state, val) {
      state.tracking.district = val;
    },
    village(state, val) {
      state.tracking.village = val;
    },
    address(state, val) {
      state.tracking.address = val;
    },
    lat(state, val) {
      state.tracking.lat = val;
    },
    lng(state, val) {
      state.tracking.lng = val;
    },
    resetTrackings(state) {
      Object.assign(state, getDefaultState());
    },
  },
  actions: {
    async GET_STUDENT_TRACKINGS(context) {
      const payload = await TrackingService.fetchTrackingsByStudent({
        studentId: router.currentRoute.params.id,
      });
      const data = payload.data.results;
      context.commit('trackings', data);
    },
    async ADD_STUDENT_TRACKING(payload) {
      await TrackingService.addTrackingRecord(payload);
    },
    async UPDATE_STUDENT_TRACKING(payload) {
      await TrackingService.updateTrackingRecord(payload);
    },
    async DELETE_STUDENT_TRACKING(payload) {
      await TrackingService.deleteTrackingRecord(payload);
    },
    async RESET_TRACKINGS_STATE(context) {
      await context.commit('resetTrackings');
    },
  },
};

export default trackings;
